export type SheetCell = string | number | boolean | null | undefined;

export type XlsxWorkbook = {
  SheetNames: string[];
  Sheets: Record<string, unknown>;
};

export type XlsxUtils = {
  book_new: () => XlsxWorkbook;
  book_append_sheet: (wb: XlsxWorkbook, sheet: unknown, name: string) => void;
  json_to_sheet: (rows: Record<string, SheetCell>[]) => unknown;
  sheet_to_json: <T>(sheet: unknown, opts?: { defval?: string }) => T[];
};

export type XlsxModule = {
  utils: XlsxUtils;
  write: (wb: XlsxWorkbook, opts: { bookType: "xlsx"; type: "array" }) => ArrayBuffer;
  read: (data: ArrayBuffer, opts: { type: "array" }) => XlsxWorkbook;
};

declare global {
  interface Window {
    XLSX?: XlsxModule;
  }
}

const XLSX_SRC = "/vendor/xlsx.full.min.js";

let loadPromise: Promise<XlsxModule> | null = null;

export async function ensureXlsx(): Promise<XlsxModule> {
  if (window.XLSX) {
    return window.XLSX;
  }
  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = XLSX_SRC;
    script.async = true;
    script.dataset.readthroughXlsx = "1";
    script.onload = () => {
      if (!window.XLSX) {
        loadPromise = null;
        reject(new Error("SheetJS 加载失败"));
        return;
      }
      resolve(window.XLSX);
    };
    script.onerror = () => {
      loadPromise = null;
      reject(new Error("无法加载 Excel 组件"));
    };
    document.head.appendChild(script);
  });

  return loadPromise;
}

export function downloadBytes(filename: string, bytes: ArrayBuffer): void {
  const blob = new Blob([bytes], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
